import { HttpClientModule } from '@angular/common/http';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { LogLevel } from 'angular-auth-oidc-client';
import { environment } from '../environments/environment';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CoreModule } from './core/core.module';
import { LayoutModule } from './layout/layout.module';
import { SignInComponent } from './layout/components/sign-in/sign-in.component';
import { MaterialComponentsModule } from './material/material-components.module';
import { DatePipe } from '@angular/common';
import { AngularFireModule } from '@angular/fire/compat';
import { BnaServicesAuthClientModule } from 'bna-angular-auth-client';
import { SwitchOrganizationPopupComponent } from './profile/switch-organization-popup/switch-organization-popup.component';
import { SignOutComponent } from './layout/components/sign-out/sign-out.component';
import { SendLearningMaterialsConfirmComponent } from './job/components/job-detail/learning-materials/send-learning-materials-confirm/send-learning-materials-confirm.component';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { AssetsReviewDetailsComponent } from './job/components/job-detail/invoice/approve/assets-review-details/assets-review-details.component';
import { AssetsExistingDetailsComponent } from './job/components/job-detail/invoice/approve/assets-existing-details/assets-existing-details.component';
import { AssetsCopilotDetailsComponent } from './job/components/job-detail/invoice/approve/assets-copilot-details/assets-copilot-details.component';
import { PopoverModule } from 'ngx-smart-popover';
import {CdkDrag} from '@angular/cdk/drag-drop';
import { AlexComponent } from './shared/components/alex/alex.component';
import { SharedModule } from './shared/shared.module';

@NgModule({
  declarations: [
    AppComponent,
    SignInComponent,
    SignOutComponent,
    SwitchOrganizationPopupComponent,
    SendLearningMaterialsConfirmComponent
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    CoreModule,
    LayoutModule,
    SharedModule,
    MaterialComponentsModule,
    BnaServicesAuthClientModule.forRoot({
      iframe_integration: environment.iframe_integration,
      authConfig: {
        config: {
          configId: environment.idp.clientId,
          authority: environment.idp.authority,
          redirectUrl: window.location.origin + '/sign-in',
          postLogoutRedirectUri: window.location.origin + '/sign-out',
          clientId: environment.idp.clientId,
          scope: environment.idp.scope,
          responseType: 'code',
          silentRenew: true,
          silentRenewTimeoutInSeconds: 60 * 1440, // 1 day
          useRefreshToken: true,
          enableIdTokenExpiredValidationInRenew: false,
          renewTimeBeforeTokenExpiresInSeconds: 600,
          tokenRefreshInSeconds: 120,
          logLevel: environment.production ? LogLevel.Error : LogLevel.Debug,
          autoUserInfo: true,
          secureRoutes: [environment.baseUrl] 
        },
      },
    }),
    AngularFireModule.initializeApp(environment.firebase),
  ],
  providers: [DatePipe, { provide: MAT_DATE_LOCALE, useValue: 'en-au' }],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule {
  constructor() {}
}
